import { Carriers } from "@redotech/redo-fulfillment-carrier-common/carrier-service-enums";
import { getPrettyCarrierName } from "@redotech/redo-fulfillment-carrier-common/carrier-service-labels";
import { fgFilterEntries } from "@redotech/redo-fulfillment-operations-common/views/fulfillment/fg-filter-catalog";
import { ArrayStringFilterOperator } from "@redotech/redo-views-common/advanced-filters/array-string-filter";
import { AdvancedTableFilter } from "@redotech/redo-web/advanced-filters/advanced-filter";
import PackageIcon from "@redotech/redo-web/icon-old/package.svg";

const entry = fgFilterEntries.selectedCarrier;

export const SelectedCarrierFilter: AdvancedTableFilter = {
  type: entry.type,
  operators: [...entry.operators],
  data: {
    name: entry.name,
    type: entry.type,
    value: [],
    operator: ArrayStringFilterOperator.ANY_OF,
  },
  itemLabel: "carrier",
  Icon: PackageIcon,
  values: [...entry.staticValues].sort((a, b) => a.localeCompare(b)),
  display: (item: Carriers) => getPrettyCarrierName(item),
  displayName: entry.displayName,
};
